var _path, _path2, _path3, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _path4, _path5, _path6, _g, _path7, _g2, _rect14, _path8, _path9, _path0, _path1, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _path10, _path11, _path12, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUndraw(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 72,
    viewBox: "0 0 63 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.6945 58.0836C35.6945 53.4281 40.0394 49.136 44.4395 49.136C45.1137 49.136 45.7674 48.9561 46.3948 49.1216C46.4033 48.9183 46.4084 47.7239 46.4084 47.5188V0.25H8.321L0.5 8.74965V63.75H36.4596C35.686 62.4512 35.6945 59.7331 35.6945 58.0836Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1327 59.0689C35.1327 53.2673 39.5716 48.5642 45.0472 48.5642C45.3464 48.5642 45.6404 48.5795 45.9353 48.6064V24.25H1.44678V62.75H35.7589C35.3435 61.5727 35.1314 60.3258 35.1327 59.0689Z",
    fill: "#FCFCFC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.935 24.25H0.973145V8.68166L8.24405 0.75H45.935V24.25Z",
    fill: "#FCFCFC"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 30.79,
    y: 5.75,
    width: 12.3053,
    height: 1,
    fill: "#E0E0E0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 30.79,
    y: 9.25,
    width: 12.3053,
    height: 1,
    fill: "#E0E0E0"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 30.79,
    y: 12.75,
    width: 12.3053,
    height: 1,
    fill: "#E0E0E0"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 30.79,
    y: 16.25,
    width: 12.3053,
    height: 1,
    fill: "#536DFE"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 30.79,
    y: 19.75,
    width: 12.3053,
    height: 1,
    fill: "#E0E0E0"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 30.79,
    y: 23.25,
    width: 12.3053,
    height: 1,
    fill: "#E0E0E0"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 7.59912,
    y: 31.25,
    width: 12.3053,
    height: 1,
    fill: "#536DFE"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 7.59912,
    y: 34.75,
    width: 12.3053,
    height: 1,
    fill: "#E0E0E0"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 7.59912,
    y: 33.25,
    width: 31.7099,
    height: 1,
    fill: "#69F0AE"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 7.59912,
    y: 40.75,
    width: 12.3053,
    height: 1,
    fill: "#536DFE"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 7.59912,
    y: 44.25,
    width: 12.3053,
    height: 1,
    fill: "#E0E0E0"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 7.59912,
    y: 42.25,
    width: 31.7099,
    height: 1,
    fill: "#E0E0E0"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 7.59912,
    y: 49.75,
    width: 12.3053,
    height: 1,
    fill: "#536DFE"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 7.59912,
    y: 53.75,
    width: 12.3053,
    height: 1,
    fill: "#E0E0E0"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 7.59912,
    y: 51.75,
    width: 26.0305,
    height: 1,
    fill: "#E0E0E0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.004 25.75H4.75977V5.2437L5.52976 4.25H7.30502H27.004V25.75Z",
    fill: "#536DFE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.973145 9.25H8.54566V0.75L0.973145 9.25Z",
    fill: "url(#paint1_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0.973145 8.75H8.07238V0.75L0.973145 8.75Z",
    fill: "#F5F5F5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.981 71.75C58.686 71.75 62.5001 67.7206 62.5001 62.75C62.5001 57.7794 58.686 53.75 53.981 53.75C49.276 53.75 45.4619 57.7794 45.4619 62.75C45.4619 67.7206 49.276 71.75 53.981 71.75Z",
    fill: "url(#paint2_linear)"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9809 70.75C58.4244 70.75 62.0267 67.0563 62.0267 62.5C62.0267 57.9437 58.4244 54.25 53.9809 54.25C49.5373 54.25 45.9351 57.9437 45.9351 62.5C45.9351 67.0563 49.5373 70.75 53.9809 70.75Z",
    fill: "#3AD29F"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.2403 61.7445H54.9317V58.25H53.0298V61.7445H49.7212V63.7546H53.0298V67.25H54.9317V63.7546H58.2403V61.7445Z",
    fill: "url(#paint3_linear)"
  }))), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 53.0342,
    y: 58.75,
    width: 1.89313,
    height: 7.5,
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5161 61.75V63.4725H50.1945V61.75H57.5161Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6867 62.0836C44.6867 57.4281 49.0316 53.136 53.4317 53.136C54.1059 53.136 54.7596 52.9561 55.387 53.1216C55.3955 52.9183 55.4006 51.7239 55.4006 51.5188V4.25H17.3132L9.49219 12.7496V67.75H45.4518C44.6782 66.4512 44.6867 63.7331 44.6867 62.0836Z",
    fill: "url(#paint4_linear)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6517 63.0689C43.6517 57.2673 48.0906 52.5642 53.5663 52.5642C53.8654 52.5642 54.1595 52.5795 54.4544 52.6064V28.25H9.96582V66.75H44.2779C43.8626 65.5727 43.6504 64.3258 43.6517 63.0689Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9277 28.25H9.96582V12.6817L17.2367 4.75H54.9277V28.25Z",
    fill: "white"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 39.7822,
    y: 9.75,
    width: 12.3053,
    height: 1,
    fill: "#E0E0E0"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 39.7822,
    y: 13.25,
    width: 12.3053,
    height: 1,
    fill: "#E0E0E0"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 39.7822,
    y: 16.75,
    width: 12.3053,
    height: 1,
    fill: "#E0E0E0"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 39.7822,
    y: 20.25,
    width: 12.3053,
    height: 1,
    fill: "#536DFE"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 39.7822,
    y: 23.75,
    width: 12.3053,
    height: 1,
    fill: "#E0E0E0"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 39.7822,
    y: 27.25,
    width: 12.3053,
    height: 1,
    fill: "#E0E0E0"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 16.5918,
    y: 35.25,
    width: 12.3053,
    height: 1,
    fill: "#536DFE"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 16.5918,
    y: 39.25,
    width: 12.3053,
    height: 1,
    fill: "#E0E0E0"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 16.5918,
    y: 37.25,
    width: 31.7099,
    height: 1,
    fill: "#69F0AE"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 16.5918,
    y: 44.75,
    width: 12.3053,
    height: 1,
    fill: "#536DFE"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 16.5918,
    y: 48.25,
    width: 12.3053,
    height: 1,
    fill: "#E0E0E0"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 16.5918,
    y: 46.75,
    width: 31.7099,
    height: 1,
    fill: "#E0E0E0"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 16.5918,
    y: 53.75,
    width: 12.3053,
    height: 1,
    fill: "#536DFE"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 16.5918,
    y: 57.75,
    width: 12.3053,
    height: 1,
    fill: "#E0E0E0"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 16.5918,
    y: 55.75,
    width: 26.0305,
    height: 1,
    fill: "#E0E0E0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9962 29.75H13.752V9.2437L14.5219 8.25H16.2972H35.9962V29.75Z",
    fill: "#536DFE"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M9.96582 13.25H17.5383V4.75L9.96582 13.25Z",
    fill: "url(#paint5_linear)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M9.96582 12.75H17.0651V4.75L9.96582 12.75Z",
    fill: "#FCFCFC"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 46.4071,
    y1: 63.75,
    x2: 46.4071,
    y2: 0.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3B3B3",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#B3B3B3",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3B3B3",
    stopOpacity: 0.05
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 8.54609,
    y1: 9.25,
    x2: 8.54609,
    y2: 0.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3B3B3",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#B3B3B3",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3B3B3",
    stopOpacity: 0.05
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 62.5001,
    y1: 71.75,
    x2: 62.5001,
    y2: 53.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 58.2403,
    y1: 67.25,
    x2: 58.2403,
    y2: 58.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 55.3993,
    y1: 67.75,
    x2: 55.3993,
    y2: 4.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3B3B3",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#B3B3B3",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3B3B3",
    stopOpacity: 0.05
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 17.5388,
    y1: 13.25,
    x2: 17.5388,
    y2: 4.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3B3B3",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#B3B3B3",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3B3B3",
    stopOpacity: 0.05
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndraw);
export default __webpack_public_path__ + "static/media/undraw.73d353df53027663426a3e606d23712f.svg";
export { ForwardRef as ReactComponent };